import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doe-chevron-icon',
  templateUrl: './chevron-icon.component.html',
  styleUrls: ['./chevron-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChevronIconComponent {}
